import { API_URL } from '../constants/constants';
import { fetch as fetchJSON } from './refreshToken.js';
import { toast } from 'react-toastify';

export async function fetchFQBN() {
  try {
    const response = await fetchJSON(`${API_URL}/device/fqbn`, {
      method: 'GET',
    });
    return response.body;
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error('Error fetching fqbn:', error);
    throw error;
  }
}

export async function fetchDevices() {
  try {
    const response = await fetchJSON(`${API_URL}/device/devices`, {
      method: 'GET',
    });
    return response.body.devices;
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error('Error fetching devices:', error);
    throw error;
  }
}

export async function getState(device_id) {
  try {
    const response = await fetchJSON(
      `${API_URL}/device/devices/${device_id}/state`,
      { method: 'GET' }
    );
    return response.body.state;
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error('Error fetching devices:', error);
    throw error;
  }
}

export async function getTarifs() {
  try {
    const response = await fetchJSON(`${API_URL}/tariffs`, { method: 'GET' });
    return response.body;
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error('Error fetching tariffs:', error);
    throw error;
  }
}

export async function getUserData() {
  try {
    const response = await fetchJSON(`${API_URL}/profile/info`, {
      method: 'GET',
    });
    return response.body;
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error('Error fetching user data:', error);
    throw error;
  }
}

export async function editFirmware(deviceId, firmwareId) {
  try {
    const response = await fetchJSON(
      `${API_URL}/device/firmware/${deviceId}?firmware_id=${firmwareId}`,
      {
        method: 'PUT',
      }
    );
    return response.body;
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error('Error fetching data:', error);
    throw error;
  }
}

export async function postDevices(
  platform,
  name,
  fqbn,
  wifi_ssid,
  wifi_password
) {
  const device = { platform, name, fqbn, wifi_ssid, wifi_password };
  try {
    const response = await fetchJSON(`${API_URL}/device/devices`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json;' },
      body: JSON.stringify(device),
    });
    return response.body.device_id;
  } catch (error) {
    if (error.status == 429) {
      toast.error(error?.body?.message);
      return null;
    }
    console.error('Error creating device:', error);
    throw error;
  }
}

export async function generateFirmware(deviceId, prompt) {
  const data = { prompt };
  try {
    const response = await fetchJSON(
      `${API_URL}/device/firmware/ai/${deviceId}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json;' },
        body: JSON.stringify(data),
      }
    );
    return response.body;
  } catch (error) {
    console.error('Error generateFirmware:', error);
    throw error;
  }
}

export async function deleteDevice(device_id) {
  try {
    await fetchJSON(`${API_URL}/device/devices/${device_id}`, {
      method: 'DELETE',
    });
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error('Error deleting device:', error);
    throw error;
  }
}

export async function cloneDevice(device_id) {
  try {
    await fetchJSON(`${API_URL}/device/devices/${device_id}/clone`, {
      method: 'POST',
    });
  } catch (error) {
    if (error.status == 429) {
      toast.error(error?.body?.message);
      return null;
    }
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error('Error clone device:', error);
    return null;
  }
}

export async function deviceRunBuild(deviceId, fqbn, libraries) {
  const data = { libraries, fqbn };
  try {
    const response = await fetchJSON(`${API_URL}/device/firmware/${deviceId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json;' },
      body: JSON.stringify(data),
    });
    return response.body.device_id;
  } catch (error) {
    if (error.status == 429) {
      toast.error(error?.body?.message);
      return null;
    }
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error('Error run build:', error);
    throw error;
  }
}

export async function getFirmware(device_id) {
  try {
    const response = await fetchJSON(
      `${API_URL}/device/firmware/${device_id}`,
      {
        method: 'GET',
      }
    );
    return response.body.firmwares;
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error(error);
    throw error;
  }
}

export async function startOTA(firmwareId) {
  try {
    const response = await fetchJSON(`${API_URL}/device/ota/${firmwareId}`, {
      method: 'POST',
    });
    return response.body;
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error(error);
    throw error;
  }
}

export async function getDeviceHistory(device_id) {
  try {
    const response = await fetchJSON(
      `${API_URL}/device/devices/${device_id}/history?from_ts=1&to_ts=1&limit=10&offset=0`,
      { method: 'GET' }
    );
    return response.body;
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error(error);
    throw error;
  }
}

export async function uploadFile(value, device_id) {
  const blob = new Blob([value]);
  const formData = new FormData();
  formData.append('firmware', blob, 'code.ino');
  try {
    const response = await fetch(
      `${API_URL}/device/firmware/upload/${device_id}`,
      {
        method: 'POST',
        headers: { Authorization: localStorage.getItem('access_token') },
        body: formData,
      }
    );
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response;
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error('Error uploading file:', error);
    throw error;
  }
}

export async function updateDeviceState(device_id, deviceState) {
  try {
    const response = await fetchJSON(
      `${API_URL}/device/devices/${device_id}/update_state`,
      {
        method: 'POST',
        body: JSON.stringify({ state: deviceState }),
      }
    );
    return response;
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error(error);
    throw error;
  }
}

export async function updateDevice(deviceId, data) {
  try {
    const response = await fetchJSON(`${API_URL}/device/devices/${deviceId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return response;
  } catch (error) {
    if (error?.status !== 422) {
      toast.error('Ошибка сети', { toastId: 'network_err' });
    }
    console.error('Error updating device:', error);
    throw error;
  }
}

export async function fetchHistory(
  deviceId,
  page,
  perPage,
  fields,
  from_ts,
  to_ts
) {
  let url = `${API_URL}/device/devices/${deviceId}/history?offset=${page}&fields=${fields}&limit=${perPage}`;
  if (from_ts) url += `&from_ts=${Math.floor(from_ts / 1000)}`;
  if (to_ts) url += `&to_ts=${Math.floor(to_ts / 1000)}`;
  try {
    const response = await fetchJSON(url);
    return response.body;
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error('Error fetching history:', error);
    throw error;
  }
}

export async function fetchHistoryForChart(
  deviceId,
  fields,
  limit,
  fromDate,
  toDate,
  aggregation,
  aggregationMethod
) {
  let url = `${API_URL}/device/devices/${deviceId}/history/chart?fields=${fields}&limit=${limit}`;
  if (fromDate) url += `&from_ts=${Math.floor(fromDate.getTime() / 1000)}`;
  if (toDate) url += `&to_ts=${Math.floor(toDate.getTime() / 1000)}`;
  if (aggregation) url += `&window=${aggregation}`;
  url += `&method=${aggregationMethod}`;
  try {
    const response = await fetchJSON(url);
    return response.body;
  } catch (error) {
    toast.error('Ошибка сети', { toastId: 'network_err' });
    console.error('Error fetching history:', error);
    throw error;
  }
}
